export default __webpack_public_path__ + "static/media/mobileBgOnboarding.9c8ca401.png";